import React from "react";
import { BRAND, IMAGES } from "../../lib/brand";

export const Footer = () => (
  <footer className="bg-black border-t-2 border-[#2d2d2d]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-3 gap-8 items-center">
      <div className="flex items-center gap-3">
        <img src={IMAGES.logo} alt={BRAND.name} className="h-14 w-14 object-contain" />
        <span className="font-display uppercase text-lg leading-none">
          Central Alberta<br /><span className="text-[#7CB518]">Junk Removal</span>
        </span>
      </div>
      <div className="text-sm text-white/60 md:text-center">
        <p>{BRAND.phone} · {BRAND.email}</p>
        <p className="mt-1">{BRAND.area}</p>
      </div>
      <div className="text-xs text-white/40 uppercase tracking-[0.2em] md:text-right">
        © {new Date().getFullYear()} {BRAND.name}<br />No dirt. No big demo. Just junk.
        <br /><a href="/login" data-testid="owner-login-link" className="text-white/30 hover:text-[#7CB518] normal-case tracking-normal">Owner Login</a>
      </div>
    </div>
  </footer>
);
